import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import style from "./style.module.scss";
export default function TrafficLightBar(props) {
    const { trafficLightSegments, vertical, onSegmentClick, onSegmentOut, onSegmentOver, highlightedSegment } = props;
    let totalValue = 0;
    const segemntsWithValues = trafficLightSegments.filter((segment) => segment.value !== 0);
    segemntsWithValues.forEach((segment) => {
        totalValue += segment.value;
    });
    const numSegments = segemntsWithValues.length;
    const segmentItems = [];
    segemntsWithValues.forEach((segment, index) => {
        const segmentPercentage = (segment.value / totalValue) * 100 + "%";
        const classesForSegment = [];
        if (index === 0) {
            classesForSegment.push(style["traffic-light-bar__item--left-radius"]);
        }
        if (index === numSegments - 1) {
            classesForSegment.push(style["traffic-light-bar__item--right-radius"]);
        }
        //If the user is over one of the segments make sure we dim the other segments.
        if (highlightedSegment && segment.id !== highlightedSegment) {
            classesForSegment.push(style["traffic-light-bar__item--dim"]);
        }
        //If we have an onclick event add the mouse pointer class.
        if (onSegmentClick) {
            classesForSegment.push(style["traffic-light-bar__item--clickable"]);
        }
        if (vertical) {
            segmentItems.push(_jsx("div", { className: classNames(style["traffic-light-bar__item"], classesForSegment), style: { height: segmentPercentage, backgroundColor: segment.color }, onMouseOver: (event) => onMouseOver(event, segment.id), onMouseOut: onMouseOut, onClick: (event) => onClick(event, segment.id) }, segment.id));
        }
        else {
            segmentItems.push(_jsx("div", { className: classNames(style["traffic-light-bar__item"], classesForSegment), style: { width: segmentPercentage, backgroundColor: segment.color }, onMouseOver: (event) => onMouseOver(event, segment.id), onMouseOut: onMouseOut, onClick: (event) => onClick(event, segment.id) }, segment.id));
        }
    });
    //User has hovered over a table row.
    function onMouseOver(event, label) {
        if (onSegmentOver) {
            onSegmentOver(event, label);
        }
    }
    //User moved off a table tow.
    function onMouseOut(event) {
        if (onSegmentOut) {
            onSegmentOut(event);
        }
    }
    //User clicked on a table row.
    function onClick(event, label) {
        if (onSegmentClick) {
            onSegmentClick(event, label);
        }
    }
    if (vertical) {
        return (_jsx("div", { className: classNames(style["traffic-light-bar"], style["traffic-light-bar--vertical"], "qa-traffic-light-bar"), children: segmentItems }));
    }
    else {
        return _jsx("div", { className: style["traffic-light-bar"], children: segmentItems });
    }
}
